import React, { useState, useEffect, useRef, useContext } from "react";
import { useNavigate } from "react-router-dom";
import "./ProdcutPage.css";
import Insights from "../../../Components/Home/Insights/Insights";
import removebg from "../../../../src/Images/New_Home/images/Untitled-3-removebg-preview.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Group78 from "../../../../src/Images/New_Home/images/Group 78.png";
import Group79 from "../../../../src/Images/New_Home/images/Group 79.png";
import Group81 from "../../../../src/Images/New_Home/images/Group 81.png";
import Group77 from "../../../../src/Images/New_Home/images/Group 77.png";
import Group76 from "../../../../src/Images/New_Home/images/Group 76.png";
import Group74 from "../../../../src/Images/New_Home/images/Group 74.png";
import Group73 from "../../../../src/Images/New_Home/images/Group 73.png";
import tick from "../../../../src/Images/New_Home/images/tick.png";
import Group83 from "../../../../src/Images/New_Home/images/Group 83.png";
// import Group84 from "../../../../src/Images/New_Home/images/Group 84.png";
// import Group85 from "../../../../src/Images/New_Home/images/Group 85.png";
import homenewrupee from "../../../../src/Images/New_Home/images/home-new_rupee-blue.png";
import rupeegreen from "../../../../src/Images/New_Home/images/home-new_rupee-green.png";
import grapnewpricinghsix from "../../../../src/Images/New_Home/images/home-new_pricing.png";

import integration1 from "../../../../src/Images/New_Home/images/home-new_integration-1.png";
import integration2 from "../../../../src/Images/New_Home/images/home-new_integration-2.png";
import integration3 from "../../../../src/Images/New_Home/images/home-new_integration-3.png";
import integration4 from "../../../../src/Images/New_Home/images/home-new_integration-4.png";
import integration5 from "../../../../src/Images/New_Home/images/home-new_integration-5.png";
import integration6 from "../../../../src/Images/New_Home/images/home-new_integration-6.png";

import integration7 from "../../../../src/Images/New_Home/images/home-new_integration-7.png";
import TradeRadarnew from "../../../../src/Images/New_Home/TradeRadarnew.png";
import integration8 from "../../../../src/Images/New_Home/images/home-new_integration-8.png";
import carddone from "../../../../src/Images/New_Home/images/carddone.png";
import googleplay from "../../../../src/Images/New_Home/images/google play.png";
import Applestore from "../../../../src/Images/New_Home/images/Apple store.png";
import carddtwo from "../../../../src/Images/New_Home/images/carddtwo.png";
import carddthree from "../../../../src/Images/New_Home/images/carddthree.png";
import TradeRadarNewProduct from "../../../../src/Images/New_Home/images/TradeRadarNewProduct.png";
import SmartOptionProduct from "../../../../src/Images/New_Home/images/SmartOptionProduct.png";
import newpage17 from "../../../../src/Images/New_Home/images/products-new-page_17.png";
import Accordion from "react-bootstrap/Accordion";
import { Container, Col, Row } from "react-bootstrap";
// import AskFaq from "./../../../../Images/askFaq.png";
import { faArrowRightLong, faCircleCheck } from '@fortawesome/free-solid-svg-icons';
import LoginPopup from "../../CommonUI/LoginPopup/LoginPopup";
import { useSelector, useDispatch } from 'react-redux';
import { userSelector, clearState, signupUser } from '../../features/User/UserSlice';
import Faq from "../../Products/Faq/Faq";
import TrackApi from "../../Activity_Track/TrackApi";
import { useCookies } from "react-cookie";

function ProdcutPage() {
  const [cookies, setCookie] = useCookies(['LeadId']);

    let navigate = useNavigate();
    window.scrollTo(0, 0);
    const [show, setShow] = useState(false);
    const childRef = useRef(null);
    const dispatch = useDispatch();
    const usrname = useSelector(state => state.user.email);
    const { isFetching, isSuccess, isError, errorMessage } = useSelector(
        userSelector
    );

    const routeKeevHome = () => {
        // let path = `/keev`;
        let path = `/Trade-Radar`;
        navigate(path);
    }
    const routeTradeRadarHome = () => {
        // let path = `/trade-radar`;
        // navigate(path);
        window.open("https://learn.moneysukh.com/option-radar");
    }
    const routeTradingViewHome = () => {
        let path = `/trading-view`;
        navigate(path);
    }
    const routeFoxTraderHome = () => {
        let path = `/FoxTrader`;
        navigate(path);
    }
    const routeTradeTronHome = () => {
        let path = `/TradeTron`;
        navigate(path);
    }
    const routeQuantmanHome = () => {
        let path = `/Quantman`;
        navigate(path);
    }
    const routeAlgobullsHome = () => {
        let path = `/AlgoBulls`;
        navigate(path);
    }
    const routeEquity = () => {
        let path = `/market/stocks`;
        navigate(path);
    }
    const routeIPO = () => {
        let path = `/market/ipo`;
        navigate(path);
    }
    const routeMutualFund = () => {
        let path = `/market/mutual-funds`;
        navigate(path);
    }
    const routeFutureAndOption = () => {
        let path = `/market/futures-and-options`;
        navigate(path);
    }
    const routeCurrency = () => {
        let path = `/market/currency`;
        navigate(path);
    }
    const routeCommodity = () => {
        let path = `/market/commodity`;
        navigate(path);
    }
    const routeSGB = () => {
        let path = `/market/sgb`;
        navigate(path);
    }
    const routeETF = () => {
        let path = `/market/etf`;
        navigate(path);
    }
    const routePricingHome = () => {
        let path = `/Pricing`;
        navigate(path);
    }
    const routeAlgoTrading = () => {
        let path = `/AlgoTrading`;
        navigate(path);
    }
    const routeSmartOptionHome = () => {
        // let path = 'https://learn.moneysukh.com/option-radar/';
        // window.location.href = path; 
        let path = `/SmartOptions`;
        navigate(path);
        
    };

    useEffect(() => {
        if (isSuccess) {
            setShow(false);

        }
        if (isError) {

            // console.log(errorMessage);
            dispatch(clearState());
        }
    }, [isSuccess, isError]);

    const clickToggleLoginPopup = (showhide) => {
        if (isSuccess) {
            window.open(
                'https://online.moneysukh.com/',
                '_blank'
            );
        }
        else {
            childRef.current.changeTogglePopup(showhide);
        }
    }
    const clickToggleLoginPopupTrade = (showhide) => {
        if (isSuccess) {
            window.open(
                ' https://traderadar.moneysukh.com/',
                '_blank'
            );
        }
        else {
            childRef.current.changeTogglePopup(showhide);
        }
    }
    const trackData=(id)=>{
        const payloadData={
          "RelatedProspectId":id,
          "ActivityNote": "product page visit",
          "mx_Custom_1": "Products",
          "mx_Custom_2": "Your product Note",
          "mx_CustomObject_81":window.location.href
         }
         TrackApi(payloadData);
      }
      useEffect(()=>{
      
    if(cookies && cookies.RelatedProspectId){
      trackData(cookies.RelatedProspectId);
    }
        
      })
    return (
        <>

            <main class="home-new-main">

                <section class="productone">
                    <div class="container">
                        <div class="row justify-content-center ">
                            <div class="col-md-6">
                                <h2>Start trading <br></br> right away!</h2>
                                <p>Experience the New World of online trading with Fast & <br></br> Stable 
                                    Trading Platform.
                                </p>
                            </div>
                            <div class="col-md-6">

                                <div class="cen text-center">
                                    <img src={removebg} class=" ms-lg-5 ms-0 center" alt="image" />
                                </div>

                            </div>
                        </div>
                    </div>
                </section>

                <section class="producttwo">
                    <div class="container">
                        <h2 class="section-heading center">Products</h2>
                        <div class="row justify-content-center text-center gy-4">
                            <div class="col-lg-4  col-md-4 col-md-4 col-sm-6">
                                <div class="back">
                                    <img src={Group78} class="img-fluid" alt="image" />
                                    <h4>Equity</h4>
                                    <p>Invest in stock from comfort of your home and earn a chance to get inflation beating returns.
                                    </p>
                                    <button onClick={routeEquity}>Know More</button>
                                </div>
                            </div>
                            <div class="col-lg-4 col-md-4 col-md-4 col-sm-6">
                                <div class="back">
                                    <img src={Group79} class="img-fluid" alt="image" />
                                    <h4>IPO</h4>
                                    <p>Get in-depth analysis of companies that are about to hit the market through Initial public offering.</p>
                                    <button onClick={routeIPO}>Know More</button>
                                </div>
                            </div>
                            <div class="col-lg-4 col-md-4 col-md-4 col-sm-6">
                                <div class="back arrows">
                                    <img src={Group81} class="img-fluid" alt="image" />
                                    <h4>Mutual Fund</h4>
                                    <p>Start with a small amount and see your corpus grow over time by investing in mutual funds.</p>
                                    <button onClick={routeMutualFund}>Know More</button>
                                </div>
                            </div>
                            <div class="col-lg-4 col-md-4 col-md-4 col-sm-6">
                                <div class="back">
                                    <img src={Group77} class="img-fluid" alt="image" />
                                    <h4>Futures & Options</h4>
                                    <p>Trade in F&O with the help of readymade option strategy builder.</p>
                                    <button className="futurebtn" onClick={routeFutureAndOption}>Know More</button>
                                </div>
                            </div>
                            <div class="col-lg-4 col-md-4 col-md-4 col-sm-6">
                                <div class="back">
                                    <img src={Group76} class="img-fluid" alt="image" />
                                    <h4>Currency</h4>
                                    <p>Trade in wide range of currency pairs to hedge, speculate or diversify your portfolio.</p>
                                    <button onClick={routeCurrency}>Know More</button>
                                </div>
                            </div>
                            <div class="col-lg-4 col-md-4 col-sm-6">
                                <div class="back">
                                    <img src={Group79} class="img-fluid" alt="image" />
                                    <h4>Commodities</h4>
                                    <p>Trade in commodities like crude oil, gold, and silver to gain from economic trends and arbitrage opportunities.
                                    </p>
                                    <button onClick={routeCommodity}>Know More</button>
                                </div>

                            </div>
                            <div class="col-lg-4 col-md-4 col-sm-6">
                                <div class="back">
                                    <img src={Group74} class="img-fluid" alt="image" />
                                    <h4>ETF</h4>
                                    <p>An ETF, also known as an exchange-traded fund is a pooled investment of assets. </p>
                                    <button onClick={routeETF}>Know More</button>
                                </div>
                            </div>
                            <div class="col-lg-4 col-md-4 col-sm-6">
                                <div class="back">
                                    <img src={Group73} class="img-fluid" alt="image" />
                                    <h4>SGB</h4>
                                    <p>SGBs are gold-denominated government securities issued by the Reserve Bank in digital
                                        form.</p>
                                    <button onClick={routeSGB}>Know More</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>


                <section class="productthree">
                    <div class="container">
                        <h2 class="section-heading center">Our Professional Tools</h2>
                        <div class="row justify-content-center flex-lg-row  flex-md-row flex-column-reverse ">
                            <div class="col-lg-6 col-md-6 ">
                                <div class="back ps-lg-0 px-4">
                                    <h4>TradingView</h4>
                                    <h5>Technical Analysis done right</h5>
                                    <h6>TradingView provides a charting platform and social <br></br> network used by 50M+ traders.
                                    </h6>
                                    <p><img src={tick} alt="image" />&nbsp;&nbsp; 100+ prebuilt most popular indicators </p>
                                    <p><img src={tick} alt="image" />&nbsp;&nbsp; 100,000+ public indicators </p>
                                    <p><img src={tick} alt="image" />&nbsp;&nbsp; 90+ smart drawing tools </p>
                                    <p><img src={tick} alt="image" />&nbsp;&nbsp; Volume Profile indicators </p>
                                    <p><img src={tick} alt="image" />&nbsp;&nbsp; Candlestick patterns recognition </p>
                                    <p><img src={tick} alt="image" />&nbsp;&nbsp; Multi-timeframe analysis </p>
                                    <p><img src={tick} alt="image" />&nbsp;&nbsp; 15+ chart types</p>
                                    {/* <button className="learnbtn" onClick={() => clickToggleLoginPopup(true)}>Learn More <FontAwesomeIcon icon={faArrowRightLong} /></button> */}
                                    <button className="learnbtn" onClick={() => navigate('/trading-view')}>Learn More <FontAwesomeIcon icon={faArrowRightLong} /></button>
                                </div>
                            </div>
                            <div class="col-lg-6 col-md-6 ">
                                <img src={Group83} class="img-fluid imgone" alt="image" />
                            </div>
                        </div>
                        <div class="row justify-content-center mt-5  ">
                            <div class="col-lg-6 col-md-6">
                                <img src={TradeRadarNewProduct} class="img-fluid imgtwo" alt="image" />
                            </div>
                            <div class="col-lg-6 col-md-6">
                                <div class="back ps-lg-5 px-4">
                                    <h4>Algo Trading</h4>
                                    <h5>No Coding Algo Platform</h5>
                                    <h6>Algorithmic trading, also known as Algo-trading, uses <br></br> automated pre-programmed
                                        trading instructions to execute trades when a set of instructions is met.</h6>
                                    <p><img src={tick} alt="image" />&nbsp;&nbsp; Backtest </p>
                                    <p><img src={tick} alt="image" />&nbsp;&nbsp; Optimize</p>
                                    {/* <p><img src={tick} alt="image" />&nbsp;&nbsp; Forward Test </p> */}
                                    <p><img src={tick} alt="image" />&nbsp;&nbsp; Automated Live Trading</p>
                                    <p><img src={tick} alt="image" />&nbsp;&nbsp; Candlestick patterns recognition </p>
                                    <p><img src={tick} alt="image" />&nbsp;&nbsp; Multiple Segments </p>
                                    <p><img src={tick} alt="image" />&nbsp;&nbsp; Limit order placement</p>
                                    <button className="learnbtn"  onClick={routeAlgoTrading}>Learn More <FontAwesomeIcon icon={faArrowRightLong} /></button>
                                </div>
                            </div>
                        </div>
                        <div class="row justify-content-center   mt-5 flex-lg-row  flex-md-row flex-column-reverse">
                            <div class="col-lg-6 col-md-6">
                                <div class="back  ps-lg-5 px-3 smartoption_productslist">
                                    <h4>Smart Options</h4>
                                    <h5>Trade Options Directly from Real Time Charts</h5>
                                    <h6>One-stop solution for options trader & scalper.</h6>
                                    <p><img src={tick} alt="image" /> <span>Get full in-depth analysis of open interest</span> </p>
                                    <p><img src={tick} alt="image" /> <span>Track your P&L and order status simultaneously</span></p>
                                    <p><img src={tick} alt="image" /> <span>Create option strategies with a single tap through basket trading</span> </p>
                                    <p><img src={tick} alt="image" /> <span>One Stop Solution for Option Trader</span> </p>
                                    <p><img src={tick} alt="image" /> <span>Hassle free options trading for pro traders</span> </p>
                                    <p><img src={tick} alt="image" /> <span>Select multiple indices (Nifty, Bank Nifty, Fin Nifty, and Midcap)</span> </p>

                                    <button className="learnbtn"  onClick={() => clickToggleLoginPopupTrade(true)}>Learn More <FontAwesomeIcon icon={faArrowRightLong} /></button>
                                </div>
                            </div>
                            <div class="col-lg-6 col-md-6">
                                <img src={SmartOptionProduct} class="img-fluid imgthree" alt="image" />
                            </div>
                        </div>
                    </div>
                </section>


                <section class="home_pricing-sc">
                    <div class="container">
                        <div class="row">

                            <div class="col-lg-6 col-md-12">
                                <h2 class="section-heading">
                                    Our Pricing
                                </h2>
                                <ul>
                                    <li>
                                        <strong>0</strong> Account Opening Charges
                                    </li>
                                    <li>
                                        <strong>0</strong> Account Maintenance Charges (For 1st Year only)
                                    </li>
                                    <li>
                                        <strong>0</strong> Charges for Research tools
                                    </li>
                                    <li>
                                        <strong>0</strong> Charges for Delivery (Plan A)
                                    </li>
                                    <li>
                                        Flexible brokerage plans
                                    </li>
                                </ul>

                                <div class="plan-container">
                                    <div class="plan-box">
                                        <p class="plan">Plan A</p>
                                        <div class="amount">
                                            <div class="rupee-container">
                                                <img src={homenewrupee} alt="image" />
                                            </div>
                                            20
                                        </div>
                                        <p class="text">Per order + FREE delivery Brokerage</p>
                                    </div>
                                    <div class="plan-box">
                                        <p class="text-green plan">Plan B</p>
                                        <div class="text-green amount">
                                            <div class="rupee-container">
                                                <img src={rupeegreen} alt="image" />
                                            </div>
                                            10
                                        </div>
                                        <p class="text">Per order only <br></br>
                                            ( No hidden charges)</p>
                                    </div>
                                </div>

                                <button class="bttn" onClick={routePricingHome}>
                                    Discover More
                                </button>

                            </div>
                            <div class="col-lg-6 col-md-12">
                                <div class=" text-center">
                                    <img src={grapnewpricinghsix} alt="image" class="img-fluid" />
                                </div>
                            </div>
                        </div>
                    </div>

                </section>


                <section class="home_integration-sc">
                    <div class="container">
                        <div class="row">
                            <div class="col-12">
                                <h2 class="section-heading center">
                                    OUR INTEGRATION
                                </h2>

                                <div class="integration-grid-container">

                                    <div class="integration-card">
                                        <div class="content">
                                            <div class="head">Fox Trader</div>
                                            <p>Powerful Charting software, where you can backtest your strategies for successful trading with 200+ conditions.</p>
                                            <button class="bttn" onClick={routeFoxTraderHome}>
                                                Get Started
                                            </button>
                                            <div class="sr-no">
                                                01
                                            </div>
                                        </div>
                                        <div class="img-container">
                                            <img src={integration1} alt="" class="img-fluid" />
                                        </div>
                                    </div>

                                    <div class="integration-card">
                                        <div class="content">
                                            <div class="head">TradingView</div>
                                            <p>Where the world charts, chats and trades markets. We're a charting platform and social network for traders and investors.</p>
                                            <button class="bttn" onClick={routeTradingViewHome}>
                                                Get Started
                                            </button>
                                            <div class="sr-no">
                                                02
                                            </div>
                                        </div>
                                        <div class="img-container">
                                            <img src={integration2} alt="" class="img-fluid" />
                                        </div>
                                    </div>

                                    <div class="integration-card">
                                        <div class="content">
                                            <div class="head">Smart Options</div>
                                            <p>Trade Options from real time charts. No more toggling in search windows to create your option strategies</p>
                                            <button class="bttn" onClick={routeSmartOptionHome}>
                                                Get Started
                                            </button>
                                            <div class="sr-no">
                                                03
                                            </div>
                                        </div>
                                        <div class="img-container">
                                            <img src={integration3} alt="" class="img-fluid" />
                                        </div>
                                    </div>

                                    {/* <div class="integration-card">
                                        <div class="content">
                                            <div class="head">TradeTron</div>
                                            <p>
                                            Powerful Algo trading platform for creating and trading Algos and strategies without having to write a single line of code
                                            </p>
                                            <button class="bttn" onClick={routeTradeTronHome}>
                                                Get Started
                                            </button>
                                            <div class="sr-no">
                                                04
                                            </div>
                                        </div>
                                        <div class="img-container">
                                            <img src={integration4} alt="" class="img-fluid" />
                                        </div>
                                    </div>

                                    <div class="integration-card">
                                        <div class="content">
                                            <div class="head">Quantman</div>
                                            <p>
                                                Quantman is an online strategy testing and trading platform. Backtest using QuantMan with over 5+ years of futures and options data. Find patterns and strategies.
                                            </p>
                                            <button class="bttn" onClick={routeQuantmanHome}>
                                                Get Started
                                            </button>
                                            <div class="sr-no">
                                                05
                                            </div>
                                        </div>
                                        <div class="img-container">
                                            <img src={integration5} alt="" class="img-fluid" />
                                        </div>
                                    </div>

                                    <div class="integration-card">
                                        <div class="content">
                                            <div class="head">StocksEmoji</div>
                                            <p>
                                                StocksEmoji is a product of Stockbox technologies that aims to fill the research gap in investment. Bringing to the market, products that support the user.
                                            </p>
                                            <button class="bttn">
                                                <a href="https://online.moneysukh.com/ " target="_blank">
                                                    Get Started
                                                </a>
                                            </button>
                                            <div class="sr-no">
                                                06
                                            </div>
                                        </div>
                                        <div class="img-container">
                                            <img src={integration6} alt="" class="img-fluid" />
                                        </div>
                                    </div> */}

                                    <div class="integration-card">
                                        <div class="content">
                                            <div class="head">Trade Radar</div>
                                            <p>
                                            Trade Radar is a no-code algorithm trading platform that provides backtesting, optimization & fully automated live trading.
                                            </p>
                                            <button class="bttn" onClick={routeKeevHome}>
                                                Get Started
                                            </button>
                                            <div class="sr-no">
                                                04
                                            </div>
                                        </div>
                                        <div class="img-container">
                                            {/* <img src={integration7} alt="" class="img-fluid" /> */}
                                            <img src={TradeRadarnew} alt="" class="img-fluid" />
                                        </div>
                                    </div>

                                    {/* <div class="integration-card">
                                        <div class="content">
                                            <div class="head">Algobulls</div>
                                            <p>
                                                Why spend years attempting to master the complexity of capital markets when AlgoBulls unique AI-driven trading algorithmic platform unlocks the potential of capital market investment.
                                            </p>
                                            <button class="bttn" onClick={routeAlgobullsHome}>
                                                Get Started
                                            </button>
                                            <div class="sr-no">
                                                08
                                            </div>
                                        </div>
                                        <div class="img-container">
                                            <img src={integration8} alt="" class="img-fluid" />
                                        </div>
                                    </div> */}

                                </div>
                            </div>
                        </div>
                    </div>

                </section>


                <section class="productfour">
                    <div class="container">
                        <h2 class="section-heading center">
                            Platforms
                        </h2>
                        <h4 class="text-center">Platforms Powered with dynamic alert, <br></br> real time feeds and a very handy
                            dashboard </h4>
                        <div class="row justify-content-center text-center gy-4">
                            <div class="col-lg-4 col-md-4 ">
                                <div className="productsec">
                                    <img src={carddone} class="img-fluid" alt="image" />
                                    <div class="posabs">
                                        <div class="flexplay imgbtn">
                                            <a href="https://play.google.com/store/apps/details?id=online.moneysukh.com&hl=en_IN"><img class="play" src={googleplay} alt="image" /></a>
                                            <a href="https://apps.apple.com/in/app/moneysukh-pro/id6739534241"><img class="play" src={Applestore} alt="image" /></a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-4 col-md-4 ">
                                <div  className="productsec">
                                    <img src={carddtwo} class="img-fluid" alt="image" />
                                    <div class="posabs">
                                        <div class="flexplay">
                                            {/* <button class="down"><a href="https://online.moneysukh.com/">Get Started</a></button> */}
                                            <span class="down"><a href="https://online.moneysukh.com/">Get Started</a></span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-4 col-md-4 ">
                                <div  className="productsec">
                                    <img src={carddthree} class="img-fluid" alt="image" />
                                    <div class="posabs">
                                        <div class="flexplay">
                                            {/* <button class="downtwo"><a href="https://moneysukh.com:8443/res/download">Download Now </a></button> */}
                                            <span class="downtwo"><a href="https://moneysukh.com:8443/res/download">Download Now </a></span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <Insights />
                <Faq />
                <LoginPopup show={show} ref={childRef} />
            </main>
        </>
    );
}

export default ProdcutPage;